import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const AsignarPromotor = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
}) => {
  const [estatus, setEstatus] = useState({});
  const [promotores, setPromotores] = useState([]);
  useEffect(() => {
    onConsultar();
  }, []);
  const onConsultar = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACJDF_Analisis_AsignarPromotor/Get?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
        setPromotores(result.promotor);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  const onAceptar = (promotor) => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idpromotor: promotor.idempleado,
      comentarios: `SE ASIGNO A ${promotor.promotor} PARA DAR SEGUIMIENTO A LA SOLICITUD`,
    };
    request
      .post("ACJDF_Analisis_AsignarPromotor/AsiganarPromotor", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
        setPromotores(result.promotor);
        if (updateComentarios !== undefined && updateComentarios !== null)
          updateComentarios();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  if (
    estatus.habilitar === undefined ||
    estatus.habilitar === null ||
    estatus.habilitar === false
  ) {
    return (
      <div className="analisis-credito-jdf-asiganar-promotor">
        <div className="analisis-credito-jdf-pedido-content">
          TIEMPO DE RESPUESTA ESTIMADO: {estatus.tiempoestimado}
        </div>
        <div
          className={`analisis-credito-jdf-content-comentarios analisis-credito-jdf-content-comentarios-${estatus.icono}`}
        >
          <div className="analisis-credito-jdf-pedido-content-comentarios-svg">
            <CheckCircleIcon />
          </div>
          <div className="analisis-credito-jdf-pedido-content-comentarios-div">
            {estatus.comentarios}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="analisis-solicitud-credito-proceso">
        <div className="analisis-solicitud-credito-proceso-container scroll-4">
          {promotores === undefined ||
          promotores === null ||
          promotores === 0 ? (
            <div>
              No existe informacion para mostrar. Favor de cominicarse con el
              administrador del sistema
            </div>
          ) : (
            <table
              cellPadding={0}
              cellSpacing={0}
              id="table-asignar-promotor-jdf"
            >
              <thead>
                <tr>
                  <th>Promotor</th>
                  <th>Asignar</th>
                </tr>
              </thead>
              <tbody>
                {promotores.map((promotor) => (
                  <tr>
                    <td>{promotor.promotor}</td>
                    <td className="jdf-asignar-promotor">
                      <CheckCircleIcon onClick={() => onAceptar(promotor)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }
};
